/* BDF POINT 8 — coordination, accessibility, forms and conversion events. */
(function(){
  'use strict';

  var modalState={active:null};
  var newsletterOpenedAt=0;
  var upsellPending=null;

  function now(){return Date.now();}
  function days(n){return n*24*60*60*1000;}
  function safeGet(key){try{return localStorage.getItem(key);}catch(e){return null;}}
  function safeSet(key,value){try{localStorage.setItem(key,value);}catch(e){}}
  function sessionGet(key){try{return sessionStorage.getItem(key);}catch(e){return null;}}
  function sessionSet(key,value){try{sessionStorage.setItem(key,value);}catch(e){}}
  function toInt(value,fallback){var n=parseInt(value,10);return Number.isFinite(n)?n:fallback;}
  function emit(name,detail){
    detail=detail||{};
    document.dispatchEvent(new CustomEvent(name,{detail:detail}));
    if(Array.isArray(window.dataLayer))window.dataLayer.push(Object.assign({event:name},detail));
  }

  function getFocusable(container){
    if(!container)return[];
    return Array.prototype.slice.call(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(node){
      return node.offsetParent!==null&&!node.hasAttribute('hidden');
    });
  }

  function trapFocus(event,container){
    if(event.key!=='Tab')return;
    var items=getFocusable(container);
    if(!items.length)return;
    var first=items[0],last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  }

  function isBlockingUiOpen(){
    return Boolean(document.querySelector('.bdf-cart-drawer.is-open,.bdf-upsell-modal.is-open,.bdf-cookie-banner.is-visible,.bdf-mobile-nav.is-open,.site-nav--mobile.is-open,.search-modal.is-open,.bdf-search-overlay.is-open,.bdf-language-overlay.is-open'));
  }

  function isNewsletterEligiblePage(){
    var body=document.body;
    if(!body)return false;
    if(body.classList.contains('template-cart')||body.classList.contains('template-product'))return false;
    if(body.className.indexOf('template-customers')!==-1)return false;
    if(document.querySelector('[data-bdf-cart-page],.pxFormGenerator,[data-bdf-form]'))return false;
    return true;
  }

  function scrollEngaged(){
    var d=document.documentElement;
    var max=Math.max(0,d.scrollHeight-d.clientHeight);
    if(max<500)return true;
    return (d.scrollTop/max)>=0.16;
  }

  function initFooter(){
    document.querySelectorAll('.bdf-footer-heading').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(window.innerWidth>768)return;
        var col=btn.closest('.bdf-footer-col');
        if(!col)return;
        var willOpen=!col.classList.contains('is-open');
        document.querySelectorAll('.bdf-footer-col.is-open').forEach(function(openCol){
          if(openCol===col)return;
          openCol.classList.remove('is-open');
          var other=openCol.querySelector('.bdf-footer-heading');
          if(other)other.setAttribute('aria-expanded','false');
        });
        col.classList.toggle('is-open',willOpen);
        btn.setAttribute('aria-expanded',willOpen?'true':'false');
      });
    });

    document.querySelectorAll('[data-bdf-cookie-manage]').forEach(function(btn){
      btn.addEventListener('click',function(event){
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('bdf:cookie:manage'));
      });
    });
  }

  function hideLegacySocialSection(){
    var legacy=document.getElementById('bdf-crew-custom-section');
    if(!legacy)return;
    var section=legacy.closest('.shopify-section')||legacy;
    section.hidden=true;
    section.setAttribute('aria-hidden','true');
  }

  function initNewsletter(){
    var modal=document.getElementById('newsletter-modal');
    if(!modal)return;

    var delay=Math.max(15000,toInt(modal.getAttribute('data-bdf-newsletter-delay'),18000));
    var cooldown=Math.max(3,toInt(modal.getAttribute('data-bdf-newsletter-cooldown'),7));
    var success=modal.querySelector('[data-bdf-newsletter-success]');
    var errors=modal.querySelector('.bdf-newsletter-error');
    var previousFocus=null;

    function close(reason,remember){
      modal.style.display='none';
      modal.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('bdf-modal-lock');
      if(remember!==false)safeSet('bdf_newsletter_closed_at',String(now()));
      modalState.active=null;
      emit('bdf_newsletter_closed',{reason:reason||'close',open_ms:newsletterOpenedAt?now()-newsletterOpenedAt:0});
      if(previousFocus&&previousFocus.focus)previousFocus.focus();
    }

    function open(reason){
      if(!isNewsletterEligiblePage()||isBlockingUiOpen()||modalState.active)return false;
      previousFocus=document.activeElement;
      modal.style.display='block';
      modal.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('bdf-modal-lock');
      modalState.active='newsletter';
      newsletterOpenedAt=now();
      emit('bdf_newsletter_view',{reason:reason||'engaged'});
      var focus=modal.querySelector('input[type=email],button,a[href]');
      if(focus)setTimeout(function(){focus.focus();},40);
      return true;
    }

    if(success){
      safeSet('bdf_newsletter_subscribed','1');
      modal.style.display='block';
      modal.setAttribute('aria-hidden','false');
      modalState.active='newsletter';
      setTimeout(function(){var closeBtn=modal.querySelector('[data-bdf-newsletter-close]');if(closeBtn)closeBtn.focus();},40);
    }else if(errors){
      modal.style.display='block';
      modal.setAttribute('aria-hidden','false');
      modalState.active='newsletter';
      var email=modal.querySelector('input[type=email]');
      if(email)setTimeout(function(){email.focus();},40);
    }

    modal.querySelectorAll('[data-bdf-newsletter-close],.btn.close,.modal-overlay').forEach(function(node){
      node.addEventListener('click',function(event){event.preventDefault();close('user',true);});
    });

    var form=modal.querySelector('form');
    if(form)form.addEventListener('submit',function(){emit('bdf_newsletter_submit_attempt');});

    document.addEventListener('keydown',function(event){
      if(modalState.active!=='newsletter')return;
      if(event.key==='Escape'){close('escape',true);return;}
      trapFocus(event,modal.querySelector('[role="dialog"]')||modal);
    });

    if(success||errors)return;
    if(safeGet('bdf_newsletter_subscribed')==='1')return;
    var lastClosed=parseInt(safeGet('bdf_newsletter_closed_at')||'0',10);
    if(lastClosed&&now()-lastClosed<days(cooldown))return;
    if(!isNewsletterEligiblePage())return;

    var eligibleAt=now()+delay;
    var hardDeadline=now()+Math.max(delay+12000,45000);
    function attempt(){
      if(safeGet('bdf_newsletter_subscribed')==='1')return;
      if(now()<eligibleAt){setTimeout(attempt,1000);return;}
      if(!scrollEngaged()&&now()<hardDeadline){setTimeout(attempt,4000);return;}
      if(!open(scrollEngaged()?'engaged':'timeout'))setTimeout(attempt,5000);
    }
    setTimeout(attempt,delay);
  }

  function suppressFutureUpsell(upsell){
    sessionSet('bdf_upsell_seen','1');
    upsell.querySelectorAll('[data-bdf-upsell-candidate],[data-bdf-upsell-product]').forEach(function(form){
      form.removeAttribute('data-bdf-upsell-product');
    });
  }

  function syncUpsellWithCart(upsell,cart){
    if(!cart||!Array.isArray(cart.items))return;
    var handles=new Set(cart.items.map(function(item){return item.handle||item.product_handle||'';}));
    var sessionSuppressed=sessionGet('bdf_upsell_seen')==='1';
    var visibleCount=0;

    upsell.querySelectorAll('.bdf-upsell-card').forEach(function(card){
      var form=card.querySelector('form[data-bdf-upsell-candidate],form[data-product-handle]');
      if(!form){card.hidden=true;return;}
      var handle=form.getAttribute('data-product-handle')||'';
      var eligible=!sessionSuppressed&&!handles.has(handle)&&visibleCount<2;
      card.hidden=!eligible;
      if(eligible){
        form.setAttribute('data-bdf-upsell-product','');
        visibleCount+=1;
      }else{
        form.removeAttribute('data-bdf-upsell-product');
      }
    });

    upsell.classList.toggle('has-no-recommendations',visibleCount===0);
  }

  function initUpsellTracking(){
    var upsell=document.querySelector('[data-bdf-upsell-modal]');
    if(!upsell)return;
    if(sessionGet('bdf_upsell_seen')==='1')suppressFutureUpsell(upsell);

    var wasOpen=upsell.classList.contains('is-open');
    new MutationObserver(function(){
      var open=upsell.classList.contains('is-open');
      if(open&&!wasOpen){
        modalState.active='upsell';
        emit('bdf_upsell_view',{product:upsell.getAttribute('data-bdf-upsell-context')||''});
      }
      if(!open&&wasOpen){
        emit('bdf_upsell_closed',{product:upsell.getAttribute('data-bdf-upsell-context')||''});
        suppressFutureUpsell(upsell);
        if(modalState.active==='upsell')modalState.active=null;
      }
      wasOpen=open;
    }).observe(upsell,{attributes:true,attributeFilter:['class']});

    upsell.addEventListener('change',function(event){
      var select=event.target.closest('select[name="id"]');
      if(!select)return;
      var form=select.closest('form[data-bdf-upsell-candidate]');
      var selected=select.options[select.selectedIndex];
      if(form&&selected&&selected.dataset.price)form.setAttribute('data-product-price',selected.dataset.price);
    });

    upsell.addEventListener('submit',function(event){
      var form=event.target;
      if(!form.matches('[data-bdf-upsell-product]'))return;
      upsellPending={
        handle:form.getAttribute('data-product-handle')||'',
        value_cents:toInt(form.getAttribute('data-product-price'),0),
        startedAt:now()
      };
      emit('bdf_upsell_add_attempt',upsellPending);
    },true);

    document.addEventListener('bdf:cart:updated',function(event){
      var cart=event.detail&&event.detail.cart;
      syncUpsellWithCart(upsell,cart);
      if(!upsellPending||!cart||!Array.isArray(cart.items))return;
      var found=cart.items.some(function(item){return (item.handle||item.product_handle||'')===upsellPending.handle;});
      if(found){
        emit('bdf_upsell_add_success',{
          product:upsellPending.handle,
          value_cents:upsellPending.value_cents,
          elapsed_ms:now()-upsellPending.startedAt,
          cart_total_cents:toInt(cart.total_price,0)
        });
        upsellPending=null;
      }
    });
  }

  function formLabel(type){
    var labels={
      contact:'CONTACT / SERVICE CLIENT',
      personnalisation:'PERSONNALISATION / DEMANDE DE DEVIS',
      'stand-evenement':'ÉVÉNEMENT / INVITER LE STAND',
      partenariat:'PARTENARIAT / DISTRIBUTION'
    };
    return labels[type]||'BOULE DE FEU / FORMULAIRE';
  }

  function enhanceFormContainer(container){
    if(!container||container.closest('.bdf-form-shell'))return;
    var type=container.getAttribute('data-bdf-form')||'';
    var shell=document.createElement('div');
    shell.className='bdf-form-shell';
    shell.setAttribute('data-bdf-form-shell',type||'generic');
    var meta=document.createElement('div');
    meta.className='bdf-form-shell__meta';
    meta.textContent=formLabel(type);
    var body=document.createElement('div');
    body.className='bdf-form-shell__body';
    var privacy=document.createElement('p');
    privacy.className='bdf-form-shell__privacy';
    privacy.innerHTML='Les informations envoyées servent uniquement à traiter cette demande. <a href="/pages/politique-de-confidentialite">Politique de confidentialité</a>.';
    container.parentNode.insertBefore(shell,container);
    shell.appendChild(meta);
    shell.appendChild(body);
    body.appendChild(container);
    shell.appendChild(privacy);

    var started=false;
    shell.addEventListener('focusin',function(){
      if(started)return;
      started=true;
      emit('bdf_form_start',{form:type||'generic'});
    });
    shell.addEventListener('submit',function(){emit('bdf_form_submit_attempt',{form:type||'generic'});},true);
  }

  function initForms(){
    document.querySelectorAll('.pxFormGenerator[data-bdf-form]').forEach(enhanceFormContainer);
    var observer=new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        mutation.addedNodes.forEach(function(node){
          if(!(node instanceof Element))return;
          if(node.matches&&node.matches('.pxFormGenerator[data-bdf-form]'))enhanceFormContainer(node);
          if(node.querySelectorAll)node.querySelectorAll('.pxFormGenerator[data-bdf-form]').forEach(enhanceFormContainer);
        });
      });
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }

  function initContrastGuards(){
    document.querySelectorAll('.bdf-site-footer,.bdf-upsell-modal__dialog,#newsletter-modal .modal-window,.bdf-cookie-banner__panel').forEach(function(node){node.classList.add('bdf-surface-dark');});
    document.querySelectorAll('.bdf-form-shell,.bdf-footer-newsletter input[type=email],#newsletter-modal input[type=email]').forEach(function(node){node.classList.add('bdf-surface-light');});
  }

  function init(){
    hideLegacySocialSection();
    initFooter();
    initForms();
    initNewsletter();
    initUpsellTracking();
    initContrastGuards();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
}());